module.exports = __webpack_public_path__ + "static/media/Pickpockie Books.e8aaaf87.png";